"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var root = document.documentElement || document;
var StickyNav = (function () {
    function StickyNav(elements) {
        var _this = this;
        if (typeof (elements) === 'string') {
            this.elements = document.querySelectorAll(elements);
        }
        else if (elements instanceof NodeList) {
            this.elements = elements;
        }
        this.elementCount = this.elements.length;
        ("scroll touchmove touchstart touchend".split(" ")).forEach(function (e) {
            window.addEventListener(e, _this.handleScroll.bind(_this), false);
        });
        this.handleScroll();
    }
    StickyNav.prototype.handleScroll = function () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        for (var i = 0; i < this.elementCount; ++i) {
            var el = this.elements.item(i);
            var togglePoint = el.offsetTop;
            if (scrollTop > togglePoint) {
                el.classList.add('sticky');
            }
            else {
                el.classList.remove('sticky');
            }
        }
    };
    return StickyNav;
}());
exports.default = StickyNav;
